import { schema } from 'normalizr'

import * as grs from '../grs'

export const locationSchema = new schema.Entity(
    'locations',
    {
        grsLocation: grs.schemas.locationSchema,
    },
    {
        processStrategy: value => {
            const result = {
                ...value,
                lat: value.geoLocation.x,
                lng: value.geoLocation.y,
            }

            if (value.grsId)
                result.grsLocation = {
                    id: value.grsId,
                }

            return result
        },
    }
)

export const POIScheme = new schema.Entity(
    'placesOfInterests',
    {},
    {
        processStrategy: value => {
            const result = {
                ...value,
                geoLocation: {
                    x: Number(value.lat),
                    y: Number(value.lon),
                },
            }

            return result
        },
    }
)
